<div
  class="input time-input"
  [class.input--icon]="showIcon"
  [ngClass]="{
    'input--highlight': highlightError | async,
    'input--invalid': !control.valid,
    'input--touched': control.touched || submitAttempted,
    'time-input--large': isLarge,
  }"
>
  @if (showIcon) {
    <ftr-icon-legacy class="input__icon" icon="Clock" color="GreyLight" />
  }
  <input
    #inputElement
    [ngClass]="{
      'input__control--has-value': internalValue !== '',
    }"
    #elem
    [attr.name]="name"
    [required]="control.hasValidator(validators.required)"
    [id]="id"
    type="text"
    class="input__control"
    autocomplete="off"
    [placeholder]="placeholder"
    [value]="internalValue"
    [class.input__control--has-value]="!!control.value"
    (change)="inputChange(elem.value)"
  />
  <label class="input__label" [htmlFor]="id">{{ label }}</label>
  <span class="input__bar"></span>
  <span
    class="input__validation"
    ftrValidationErrorHint
    [ngFormControl]="control"
    [controlTouched]="control.touched"
    [submitAttempted]="submitAttempted"
    [label]="label"
  ></span>
</div>
